import script from "./MasTraining.vue?vue&type=script&setup=true&lang=ts"
export * from "./MasTraining.vue?vue&type=script&setup=true&lang=ts"

import "./MasTraining.vue?vue&type=style&index=0&id=79519769&lang=css"

const __exports__ = script;

export default __exports__